<div>
  <h2>{{'PROJECTS_MODULE.DISCUSSION.discussionHeader' | translate}}:</h2>
  <div>
    <ng-content></ng-content>
  </div>
</div>
